import { render, staticRenderFns } from "./AffiliateMenu.vue?vue&type=template&id=55991714&"
import script from "./AffiliateMenu.vue?vue&type=script&lang=js&"
export * from "./AffiliateMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports